import { Link, useParams } from 'react-router-dom';

import { PaymentType } from '@marxbiotech/shared-types/bff';
import { OrderInfo, ShippingInfo } from '@modules/order/components/order-details';
import type { OrderDetailData } from '@modules/order/components/order-details/types';
import Text from '@modules/common/components/text';

interface OrderConfirmedDetailsProps {
  order: OrderDetailData;
}

const OrderConfirmedDetails = ({ order }: OrderConfirmedDetailsProps) => {
  const { countryCode = 'tw' } = useParams<{ countryCode: string }>();
  const buyerData = order.cart?.metadata;
  const isDepositWithLoan =
    order.marxPayment?.type === PaymentType.DEPOSIT_WITH_LOAN;

  return (
    <>
      <div className="flex flex-col justify-center gap-4 text-center">
        <Text variant="h2-bold" as="h2">
          感謝您！訂單
          {isDepositWithLoan ? '審核中！' : '已成立！'}
        </Text>
        <p className="text-black-10">
          訂單編號:
          <Link
            to={`/${countryCode}/account/orders/details/${order.id}`}
            data-testid="order-id"
            className="ml-2 text-blue-600 hover:text-blue-800 hover:underline"
          >
            #{buyerData?.order_number ?? order.display_id ?? order.id}
          </Link>
        </p>
        {buyerData?.buyer_email && (
          <p className="text-black-10">
            成立的訂單資訊已送至您留存的下列電子郵件：
            <span
              className="text-ui-fg-medium-plus font-semibold"
              data-testid="order-email"
            >
              {buyerData.buyer_email}
            </span>
          </p>
        )}
        {isDepositWithLoan && (
          <p className="text-black-10">
            賒帳訂單需經內部人員審核，審核通過後訂單狀態將轉為「訂單處理中」，並開始準備出貨
          </p>
        )}
      </div>
      <div className="flex gap-6">
        <OrderInfo order={order} />
        <ShippingInfo order={order} />
      </div>
    </>
  );
};

export default OrderConfirmedDetails;
